<template>
  <el-container
    class="internalQualityControl"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <el-header></el-header>
    <el-main>
      <div class="qc-container">
        <div class="qc-container-left">
          <div class="today-quality">
            <el-button @click="$router.push({path:'/taskList',query:{fixed:10}})" size="mini" plain>返回</el-button>
            <div>
              <span style="margin-right: 10px;">今日质控：{{todayQualityCount}}人</span>
              <el-checkbox v-model="searchData.isShowOwnQuality" @change="searchDataHandler">仅查看我的质控</el-checkbox>
            </div>
          </div>
          <div class="search-content">
            <div class="search-item">
              <el-input v-model="searchData.patientName" placeholder="患者姓名或住院号" @change="searchDataHandler" clearable></el-input>
            </div>
            <div class="search-item">
              <el-select v-model="searchData.state" placeholder="请选择随访状态" @change="searchDataHandler" clearable>
                <el-option
                  v-for="item in followUpState"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="search-item">
              <el-select v-model="searchData.seatId" placeholder="请选择坐席" @change="searchDataHandler" clearable>
                <el-option
                  v-for="item in seatLists"
                  :key="item.callCenterUserId"
                  :label="item.callCenterUserName"
                  :value="item.callCenterUserId">
                </el-option>
              </el-select>
            </div>
            <div class="search-item">
              <el-date-picker
                @change="searchDataHandler"
                v-model="searchData.date"
                type="date"
                placeholder="选择日期"
                clearable>
              </el-date-picker>
            </div>
            <div class="search-item">
              <el-select v-model="searchData.isQC" placeholder="是否质控" @change="searchDataHandler" clearable>
                <el-option
                  v-for="item in qcState"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="search-item">
              <el-select @change="searchDataHandler" v-model="searchData.qualityResultDynamic" filterable clearable
                        placeholder="请选择质控结果动态">
                  <el-option :label="item.label" :value="item.value" v-for="(item,index) in qualityResultDynamicList"
                            :key="index"></el-option>
              </el-select>
            </div>
            <!-- <div class="search-item-prompt">
              <span class="qc-dot">未质控</span><span class="qc-dot">已质控</span>
            </div> -->
          </div>
          
          <div class="list-content">
            <div v-if="patientLists.length == 0" class="qc-empty">
              <img src="./img/no-result.png" alt="loading" style="width:180px;margin-bottom: 20px;">
              <span style="margin-bottom: 20px;">暂无数据</span>
            </div>
            <div v-for="(item, index) in patientLists" :key="index" :class="item.isSpotCheck == 0? '': 'list-item-green'">
              <div :class="item.isActive?'patient-item patient-item-active':'patient-item'" @click="getpatientDetail(item)">
                <span>{{ item.patientName }}</span>
                <span>{{ item.hospitalId }}</span>
                <span>{{ item.followUpStateName }}</span>
                <span>{{ item.calledNumber }}</span>
                <span>{{ item.followupCompleteTime }}</span>
                <span>{{ item.callSeat }}</span>
                <span class="step-box" v-show="item.qualityResultStep!=4">
                  <label>质控进度：</label>
                  <span v-if="item.qualityResultStep==4">暂无</span>
                  <!-- <span v-else-if="item.qualityResultStep==5">审核不通过</span> -->
                  <el-steps v-else-if="item.qualityResultStep==5" :active="1" class="not-pass" align-center>
                    <el-step title=""></el-step>
                    <el-step title="审核不通过" icon="el-icon-error"></el-step>
                    <el-step title=""></el-step>
                    <el-step title=""></el-step>
                  </el-steps>
                  <el-steps v-else :active="item.qualityResultStep" class="has-steps" align-center>
                    <el-step  v-for="(item, index) in qualityResultSteps" :key="index" :title="item.label">
                      <span slot="icon">
                          <span class="step-dot" style="color:rgba(0,0,0,0);font-size: 28px;">s</span>
                      </span>
                    </el-step>
                  </el-steps>
                </span>
                <!-- <span style="width: 15px;">{{item.qualityResultStep}}</span> -->
              </div>
            </div>
          </div>
          <div class="pagination" style="overflow:auto;">
            <el-pagination
                background
                small
                layout="total, prev, pager, next, jumper"
                :page-count="totalPage"
                :current-page="currentPage"
                @current-change="current_change"
            ></el-pagination>
          </div>
        </div>
        <div class="qc-container-right">
          <div class="questionaire-container">
            <div class="right-title">
                <div>
                    问卷填写结果
                </div>
            </div>
            
            <div v-if="taskStaus.isNewTask&&taskStaus.questionnaireId" class="question-container">
                <questionNew :taskId="taskId" :key="timer" :admitNo="patientInfo.hospitalId" type="readonly"></questionNew>
            </div>
            <div v-if="!taskStaus.isNewTask&&taskStaus.questionnaireId">
                <question-tree-node :patientId="patientInfo.followupPatientId" ref="questionTreeNode" :questionId="taskStaus.questionnaireId" type="readonly" :key="timer"></question-tree-node>
            </div>
          </div>
          <div class="oparation-container">
            <QualityControlOperation :patientInfo="patientInfo"/>
          </div>
        </div>
      </div>
    </el-main>
    <el-footer>
      <Footer></Footer>
    </el-footer>
  </el-container>
</template>
<script>
import Footer from "../common/Footer";
import questionNew from ".././question_Third/question";
import questionTreeNode from '.././questionPreview/question-root-node-old'
import QualityControlOperation from "./components/QualityControlOperation"

import {
  RestFeedbackOutControllerQueryFollowUpPeopleTaskList, //坐席
  RestFeedbackOutControllerGetAbleSpotCheckUserList, //可抽查的用户列表
  RestFeedbackOutControllerGetFollowupTaskCurrentState,
  RestFeedbackOutControllerQueryOnlyQuestionAndAnswer,
  RestFeedbackOutControllerAddFollowupQualityTime, //质控开始时间
  RestFeedbackOutControllerUpdateFollowupQualityTime, //质控结束时间
  RestFeedbackOutControllerGetTodayQualityCount
} from "@src/assets/js/api.js";
import { mapGetters } from "vuex";

export default {
  name: "internalQualityControl",
  data() {
    return {
      // inject: ['onload'], // 注入函数
      userId: localStorage.getItem('huidrUserId'),
      searchData: {
        patientName:this.$route.query.adNo,
        isShowOwnQuality: false
      },
      followUpState: [{value:9,label:'成功'},{value:11,label:'拒绝随访'},{value:10,label:'失访'}],
      qcState:[{value:0,label:'未质控'},{value:1,label:'已质控'}],
      seatLists: [],
      patientLists:[],
      patientInfo: {},
      taskId: localStorage.getItem('taskId'),
      taskStaus: {},
      questionResult: [],
      timer:null,
      followupQualityId: null,
      urlAdminNo:this.$route.query.adNo,
      // pagination ========
      totalPage: 1,
      currentPage: 1,
      todayQualityCount: 0, //今日质控人数
      qualityResultDynamicList:[
        { label: '质控结果已提交（待审核）', value: 1 },
        { label: '审核不通过', value: 2 },
        { label: '审核通过（已发送坐席）', value: 3 },
        { label: '坐席已读（待跟踪）', value: 4 },
        { label: '坐席已编辑（待跟踪）', value: 5 },
        { label: '质控完成', value: 6 },
        { label: '暂无', value: 0 },
      ],
      qualityResultSteps:[
        { label: '已提交（待审核）', value: 0 },
        // { label: '审核不通过', value: 2 },
        { label: '审核通过（已发送坐席）', value: 1 },
        { label: '坐席已读', value: 2 },
        { label: '完成', value: 3 },
      ]
    };
  },
  components: {Footer, QualityControlOperation,questionNew,questionTreeNode},
  computed: {
    ...mapGetters(["userid", "getTaskCenterId"])
  },
  watch: {
    $route: { // 监听路由的参数变化
      handler (val,old_val) { // 数据变化更新数据
          this.searchData= {
            patientName:this.$route.query.adNo
          },
          this.taskId= localStorage.getItem('taskId')
              this.onload()
      },
      immediate: true // 立即执行
    }
  },
  mounted() {
    this.onload()
  },
  // ==========进入页面时和离开页面时========
  beforeRouteLeave(to, from, next) {
      this.updateFollowupQualityTimeAsync()
      next()
  },
  methods: {
    onload(){
      this.addFollowupQualityTime()
      this.getSeatListAsync().then(res => {
        this.seatLists = res.retValue
      })
      this.getTodayQualityCountAsync().then(res => {
        this.todayQualityCount = res.retValue
      })
      this.searchDataHandler()
    },
    addFollowupQualityTime() {
        this.addFollowupQualityTimeAsync(this.patientInfo.followupPatientId).then(res => {
            console.log("质控开始")
            this.followupQualityId = res.retValue
        });
    },
    searchDataHandler(){
      let seatIdArr=[]
      let stateArr= []
      this.searchData.seatId ?seatIdArr.push(this.searchData.seatId):seatIdArr=[]
      this.searchData.state?stateArr.push(this.searchData.state):stateArr=[]
      let data = {
        followUpTaskId: this.taskId,
        nowSeatId: this.userid,
        nameOrHospitalization: this.searchData.patientName,
        callSeatId: seatIdArr,   
        followUpStateId: stateArr,
        isSpotCheck: this.searchData.isQC,
        finishData: this.searchData.date? this.getTime(this.searchData.date) : null,
        isShowOwnQuality: this.searchData.isShowOwnQuality,
        qualityResultDynamic: this.searchData.qualityResultDynamic
      }
      this.getAbleSpotCheckUserListAsync(data).then(res => {
        if(res.status == 0) {
          if (res.retValue.length >0) {
            this.patientLists = res.retValue.map((item,index) => {
              this.$store.dispatch('getFollowupStatus', {status: item.followUpStateId})
                  .then(status => {
                      item.followUpStateName = status
                      item.isActive = false
                      index==0?item.isActive = true:item.isActive = false
                  })
              item.qualityResultStep = this.stepHandle(item.qualityResultDynamic)
              
              return item
            })
            this.patientInfo = this.patientLists[0]  //默认第一个
            this.getFollowupTaskCurrentState()
            this.totalPage = res.totalPage;
            this.currentPage = res.page;
          }else {
            this.patientLists =[]
            this.patientInfo={}
          }
        }
      })
    },
    getpatientDetail(param) {
      this.patientInfo = param;
      this.patientLists = this.patientLists.map(item => {
        item.patientId == param.patientId?item.isActive = true:item.isActive = false;
        return item;
      })
      this.getFollowupTaskCurrentState()
    },
    getFollowupTaskCurrentState() {
      this.getFollowupTaskCurrentStateAsync()
        .then(res => {
          if (res.status == 0) {
            this.taskStaus = res.retValue
            this.timer = new Date().getTime()
          }
        })
    },
    getTime(time) {
        var year = new Date(time).getFullYear()
        var month = new Date(time).getMonth() + 1 < 10 ? `0${new Date(time).getMonth() + 1}` : new Date(time).getMonth() + 1
        var day = new Date(time).getDate() < 10 ? `0${new Date(time).getDate()}` : new Date(time).getDate()
        return `${year}-${month}-${day} 00:00:00`
    },
    // 分页 交互
    current_change(currentPage) {
      console.log("page changes", arguments, currentPage);
      this.currentPage = currentPage;
      this.searchDataHandler()
    },
    // stepHandle
    stepHandle(p){
      // 质控结果动态
      // { label: '质控结果已提交（待审核）', value: 1 },
      //   { label: '审核不通过', value: 2 },
      //   { label: '审核通过（已发送坐席）', value: 3 },
      //   { label: '坐席已读（待跟踪）', value: 4 },
      //   { label: '坐席已编辑（待跟踪）', value: 5 },
      //   { label: '质控完成', value: 6 },
      //   { label: '暂无', value: 0 },
      // 步骤条的数据
      //   { label: '质控结果已提交（待审核）', value: 1 },
      //   { label: '审核通过（已发送坐席）', value: 2 },
      //   { label: '坐席已读', value: 3 },
      //   { label: '质控完成', value: 4 },
      switch (p*1) {
        case 1: return 0;
        case 2: return 5; // 审核不通过
        case 3: return 1;
        case 4: return 2;
        case 5: return 2; 
        case 6: return 3;
        case 0: return 4; // 暂无
      }
    },
    // ==============================
    async getSeatListAsync() {
      let request = new RestFeedbackOutControllerQueryFollowUpPeopleTaskList()
      request.p_nowSeatId = this.userid
      request.p_followUpTaskId = this.taskId
      await request.send()
      return request.result
    },
    async getAbleSpotCheckUserListAsync(p) {
      let request = new RestFeedbackOutControllerGetAbleSpotCheckUserList()
      request.p_followUpTaskId=p.followUpTaskId,
      request.p_nowSeatId= p.nowSeatId,
      request.p_nameOrHospitalization= p.nameOrHospitalization,
      request.p_callSeatId= p.callSeatId,
      request.p_followUpStateId= p.followUpStateId,
      request.p_isSpotCheck= p.isSpotCheck,
      request.p_finishData= p.finishData,
      request.p_isShowOwnQuality=p.isShowOwnQuality
      request.p_qualityResultDynamic = p.qualityResultDynamic
      request.p_pageIndex = this.currentPage;
      request.p_pageSize = 10;
      await request.send()
      return request.result
    },
    // 问卷相关
    async getFollowupTaskCurrentStateAsync() {
        let request = new RestFeedbackOutControllerGetFollowupTaskCurrentState()
        request.p_followUpTaskId = this.taskId
        request.p_followUpTaskPatientInfoId = this.patientInfo.followupPatientInfoId
        request.p_followUpPatientId = this.patientInfo.followupPatientId
        await request.send()
        return request.result
    },
    async queryOnlyQuestionAndAnswerAsync(p) {
        let request = new RestFeedbackOutControllerQueryOnlyQuestionAndAnswer()
        request.p_followupPatientId = p.followupPatientId
        request.p_questionnaireNewId = p.questionnaireNewId
        await request.send()
        return request.result
    },
    // 质控开始时间 this.getTaskCenterId
    async addFollowupQualityTimeAsync(fpid) {
        let request = new RestFeedbackOutControllerAddFollowupQualityTime();
        request.p_followupPatientId = fpid;
        request.p_followUpTaskId = this.getTaskCenterId;
        request.p_spotCheckUserId = sessionStorage.getItem('userid');
        await request.send();
        return request.result;
    },
    // 质控结束时间
    async updateFollowupQualityTimeAsync() {
        let request = new RestFeedbackOutControllerUpdateFollowupQualityTime();
        request.p_id = this.followupQualityId;  //质控记录id
        console.log('质控结束');
        await request.send();
        return request.result;
    },
    // 获取今日质控人数
    async getTodayQualityCountAsync() {
      let request = new RestFeedbackOutControllerGetTodayQualityCount()
      request.p_seatId = this.userid
      request.p_followUpTaskId = this.taskId
      await request.send()
      return request.result
    },
  }
};
</script>
<style lang="scss" >
.internalQualityControl {
  .qc-container {
    .el-date-editor.el-input {
      width: 100%
    }
  }
  .page-container .page-container-inner .question-list {
    height: calc(100vh - 200px) !important;
  }
  .page-container .page-container-inner .page-outline {
    height: calc(100vh - 200px) !important;
    overflow: auto;
  }
}
</style>
<style lang="scss" scoped>
.internalQualityControl {
  .qc-container {
    height: calc(100vh - 120px);
    display: grid;
    grid-template-columns: 25% 1fr;
    grid-template-rows: 100%;
    grid-column-gap: 10px;
    padding: 10px;
    overflow: auto;
    &-left{
      display: grid;
      grid-template-rows: 30px 160px 1fr 30px;
      .today-quality {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .search-content {
        display: flex;
        flex-wrap: wrap;
        .search-item {
          width: 50%;
          padding: 10px;
          padding-bottom: 0;
        }
        .search-item-prompt {
          width: 50%;
          height: 50px;
          line-height: 60px;
          .qc-dot {
            font-size: 14px;
            margin-right: 10px;
          }
          .qc-dot::before {
            content: '00';
            box-sizing: border-box;
            border-radius: 10px;
            background: #D8F9E6;
            color: #D8F9E6;
            border: 1px solid #ccc;
            font-size: 0.5em;
          }
          .qc-dot:first-child::before {
            background: #F2F2F2;
            color: #F2F2F2;
          }

        }
      }
      .list-content {
        margin-top: 10px;
        padding: 0 10px;
        overflow: auto;
        .patient-item {
          margin: 10px 0;
          padding: 10px;
          line-height: 26px;
          border-radius: 5px;
          background: #f4f4f4;
          display: flex;
          flex-wrap: wrap;
          cursor: pointer;
          box-sizing: border-box;
          span {
            width: 33%;
            font-size: 14px;
          }

        }
        .patient-item:hover, .patient-item-active:hover ,.list-item-green .patient-item:hover{
          border: 1px solid #409EFF;
          padding: 9px;
        }
        .patient-item-active {
          border: 1px solid #409EFF;
          padding: 9px;
        }
        
        .list-item-green .patient-item {
          background: #F0FFF7;
        }
        // 质控进度
        .step-box {
          flex: 1;
          display: flex;
          &>label {
            width: 20%;
          }
          .el-steps {
            width: 80%;
          }
        }

      }
      .qc-empty {
        height: 100%;
        display: flex;
        padding-top: 15%;
        align-items: center;
        flex-direction: column;
      }
    }
    &-right {
      display: flex;
      .questionaire-container {
        // border: 1px solid ;
        border: 1px solid #ccc;
        margin-right: 15px;
        border-radius: 6px;
        padding: 10px 0;
        flex: .5;
        .right-title {
          margin-bottom: 10px;
          font-weight: bold;
        }

        p {
                    margin: 0;
                    padding: 10px 41px;
                    font-size: 16px;
        }

        .question-title {
            background-color: #f9f9f9;
            color: #716363;
        }

        .question-answer {
            color: #248cfa;
        }

        .images {
            padding-left: 41px;
        }

        .cannotEdit {
            width: 100%;
            height: 100%;
            position: absolute;
            background-color: rgba(0, 0, 0, .05);
            z-index: 999;
        }
      }
      .oparation-container {
        flex: .5
      }
    }
  }
}

</style>
<style lang="scss">
  .patient-item{
    // 步骤条修改

    .el-step__main {
      .el-step__title.is-finish, .el-step__title.is-wait {
        display: none;
      }

      .el-step__title {
        font-size: 12px;
        line-height: 14px;
        font-weight: normal;
      }
    }

    .has-steps, .not-pass {
      .el-step__icon.is-text {
        width: 8px;
        height: 8px;
        border: 4px solid #C0C4CC;
        &>span {
          // width: 10px;
          // height: 10px;
        }
      }
      .el-step__head.is-process, .el-step__head.is-finish{
        .el-step__icon.is-text {
          
          border: 4px solid #51C41B;
        }
      }
      .el-step__head.is-finish{
        color: #51C41B;
        border-color: #51C41B;
      }
      .el-step__head.is-finish .el-step__line{
        background: #51C41B !important;
      }
    }
    .not-pass  {

      .el-step__head.is-process, .el-step__head.is-finish{
        .el-step__icon.is-text {
          color:rgba(0,0,0,0);
          border: 4px solid #DE5313;
        }
      }
      .el-step__icon-inner{
        color:rgba(0,0,0,0);
      }
      .el-step__head.is-finish{
        color: #DE5313;
        border-color: #DE5313;
      }
      .el-step__head.is-finish .el-step__line{
        background: #DE5313 !important;
      }
      .el-step__icon.is-icon {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        .el-step__icon-inner {
          font-size: 14px;
          color: #DE5313;
        }
      }
    }
  }
</style>